<app-side-menu>
  <div class="vehicles-content">
    <div class="row">
      <div class="col-12">
        <div class="filters-section">
          <div class="filters-row">
            <div class="filter-group">
              <label for="statusFilter" class="form-label">Filtrar por Status:</label>
              <div *ngIf="loadingStatuses" class="loading-statuses">
                <i class="fas fa-spinner fa-spin me-2"></i>
                Carregando status...
              </div>
              <select
                *ngIf="!loadingStatuses"
                id="statusFilter"
                class="form-select"
                [(ngModel)]="filters.status"
                (change)="applyFilters()">
                <option *ngFor="let option of statusOptions" [value]="option.value">{{ option.label }}</option>
              </select>
            </div>

            <div class="filter-group">
              <label for="brandFilter" class="form-label">Filtrar por Marca:</label>
              <select
                id="brandFilter"
                class="form-select"
                [(ngModel)]="filters.brand"
                (change)="applyFilters()">
                <option *ngFor="let option of brandOptions" [value]="option.value">{{ option.label }}</option>
              </select>
            </div>

            <div class="filter-group">
              <label for="ownershipFilter" class="form-label">Filtrar por Propriedade:</label>
              <select
                id="ownershipFilter"
                class="form-select"
                [(ngModel)]="filters.ownershipType"
                (change)="applyFilters()">
                <option *ngFor="let option of ownershipOptions" [value]="option.value">{{ option.label }}</option>
              </select>
            </div>

            <div class="filter-actions">
              <button type="button" class="btn btn-outline-secondary" (click)="clearFilters()">
                <i class="fas fa-times me-2"></i>
                Limpar Filtros
              </button>
              <button type="button" class="btn btn-success" (click)="openExportModal()">
                <i class="fas fa-file-excel me-2"></i>
                Exportar para Excel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="vehicles-card">
<div class="vehicles-table" *ngIf="isLoading || (vehicles && vehicles.length > 0) || filters.status || filters.brand || filters.ownershipType || filters.search">
            <app-table
              [title]="tableTitle"
              [data]="filteredVehicles"
              [loading]="isLoading"
              [columns]="[
                { titulo: 'Placa', label: 'plateNumber' },
                { titulo: 'Chassi', label: 'chassisNumber' },
                { titulo: 'Marca', label: 'brand' },
                { titulo: 'Modelo', label: 'model' },
                { titulo: 'Propriedade', label: 'ownershipType' },
                { titulo: 'Situação', label: 'status' }
              ]"
              [showSearch]="showSearch"
              [searchPlaceholder]="searchPlaceholder"
              [searchTerm]="filters.search"
              [clickable]="true"
              [actions]="actions"
              [disablePagination]="false"
              [totalItemsFromBackend]="totalItems"
              [itemsPerPage]="pageSize"
              [currentPageFromBackend]="page"
              [hasNextPageFromBackend]="hasNextPage"
              [hasPreviousPageFromBackend]="hasPreviousPage"
              [enableSorting]="true"
              [sortableColumns]="['plateNumber', 'chassisNumber', 'brand', 'model', 'ownershipType', 'status']"
              (rowClick)="view($event)"
              (actionClick)="onActionClick($event)"
              (searchChange)="onSearchChange($event)"
              (sortChange)="onSortChange($event)"
              (pageChange)="onPageChange($event)"
              (pageSizeChange)="onPageSizeChange($event)">
              <app-button
                *appHasPermission="'Vehicles.Create'"
                table-header-action
                text="Novo Veículo"
                [color]="'var(--primary-light)'"
                [height]="'42px'"
                className="new-vehicle-btn"
                (buttonClick)="newVehicle()">
              </app-button>
            </app-table>
          </div>

          <div *ngIf="!isLoading && (!vehicles || vehicles.length === 0) && !filters.search && !filters.status && !filters.brand && !filters.ownershipType" class="empty-state">
            <i class="fas fa-car"></i>
            <h3>Nenhum veículo encontrado</h3>
            <p>Cadastre um veículo para começar a gerenciar sua frota.</p>
            <app-button
              *appHasPermission="'Vehicles.Create'"
              text="Cadastrar Veículo"
              color="var(--primary-color)"
              (buttonClick)="newVehicle()"
              className="btn-primary">
              <i class="fas fa-plus me-2"></i>
            </app-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-modal
    [isOpen]="showExportModal"
    title="Exportar para Excel"
    [size]="'lg'"
    [closable]="true"
    (close)="closeExportModal()">
    <div class="report-form">
      <div class="report-section mb-4">
        <h5 class="section-title">
          <i class="fas fa-columns me-2"></i>
          Colunas da tabela Veículos
        </h5>
        <p class="text-muted small mb-3">Selecione as colunas que deseja incluir no arquivo Excel.</p>
        <div *ngIf="loadingExportColumns" class="text-center py-3">
          <i class="fas fa-spinner fa-spin me-2"></i>
          Carregando colunas...
        </div>
        <div *ngIf="!loadingExportColumns && availableExportColumns.length === 0" class="alert alert-info">
          Nenhuma coluna disponível para exportação.
        </div>
        <div *ngIf="!loadingExportColumns && availableExportColumns.length > 0">
          <div class="field-actions mb-3">
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="selectAllExportColumns()">
              <i class="fas fa-check-double me-1"></i>
              Selecionar Todas
            </button>
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="deselectAllExportColumns()">
              <i class="fas fa-times me-1"></i>
              Desmarcar Todas
            </button>
          </div>
          <div class="fields-grid">
            <div *ngFor="let col of availableExportColumns" class="field-checkbox">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [id]="'col-' + col"
                  [checked]="isExportColumnSelected(col)"
                  (change)="toggleExportColumn(col)">
                <label class="form-check-label" [for]="'col-' + col">
                  {{ getExportColumnLabel(col) }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="exportError" class="alert alert-danger">
        <i class="fas fa-exclamation-triangle me-2"></i>
        {{ exportError }}
      </div>
    </div>
    <div slot="footer" class="modal-footer-buttons">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="closeExportModal()"
        [disabled]="isExporting">
        Cancelar
      </button>
      <button
        type="button"
        class="btn btn-success"
        (click)="exportToExcel()"
        [disabled]="isExporting || loadingExportColumns">
        <span *ngIf="isExporting" class="spinner-border spinner-border-sm me-2"></span>
        <i *ngIf="!isExporting" class="fas fa-file-excel me-2"></i>
        {{ isExporting ? 'Exportando...' : 'Exportar' }}
      </button>
    </div>
  </app-modal>
</app-side-menu>
